export default __webpack_public_path__ + "static/media/paper2.4c6db4d9.svg";